import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";

// auth
import Login from "./auth/Login";
import ProtectedRoute from "./auth/ProtectedRoute";

// admin
import AdminLayout from "./admin/components/layout/AdminLayout";
import DashboardPage from "./admin/pages/DashboardPage";
import ConversationsPage from "./admin/pages/ConversationsPage";
import LeadsPage from "./admin/pages/LeadsPage";
import AgendaPage from "./admin/pages/AgendaPage";
import TasksPage from "./admin/pages/TasksPage";
import ReportsPage from "./admin/pages/ReportsPage";
import Settings from "./admin/pages/SettingsPage";

// institucional
import Home from "./pages/Home";

const theme = createTheme({
  typography: {
    fontFamily:
      '"Inter", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
  },
  palette: {
    mode: "light",
    primary: { main: "#1e1e1e" }, // cise-blue
    secondary: { main: "#c9191f" }, // cise-red
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
    text: {
      primary: "#0f172a",
      secondary: "#64748b",
    },
  },
  shape: { borderRadius: 12 },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <BrowserRouter>
        <Routes>
          {/* PUBLIC */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />

          {/* ADMIN (PROTEGIDO) */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <DashboardPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/conversas"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ConversationsPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/leads"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <LeadsPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/agenda"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AgendaPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/tarefas"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <TasksPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/relatorios"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ReportsPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/configuracoes"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Settings />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}